export enum TemplateUsageType {
  Genaral = 0,
  Event = 2,
  SocialMedia = 3,
  Campaign = 1,
  EmailSignature = 4,
  DonationForms = 5,
  Letter = 6
}